<template>
  <div>
    <v-text-field :value="value" :label="label" class="editor__label" />
    <quill-editor
      ref="myTextEditor"
      v-model="content"
      :options="editorOption"
      :placeholder="label"
    />
    <v-text-field
      :value="htmlWithoutTags"
      :rules="rules"
      class="editor__error-message"
    />
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

import { i18n } from '@/plugins/i18n/i18n';

const buttonTooltips = {
  'ql-bold': 'Bold',
  'ql-italic': 'Italic',
  'ql-underline': 'Underline',
  'ql-strike': 'Strike',
  'ql-blockquote': 'Block quote',
  'ql-code-block': 'Code block',
  'ql-header': {
    '1': 'Header 1',
    '2': 'Header 2',
  },
  'ql-align': {
    '': 'Align left',
    center: 'Align center',
    right: 'Align right',
    justify: 'Align justify',
  },
  'ql-list': {
    ordered: 'Numbered list',
    bullet: 'Bulleted list',
  },
  'ql-indent': {
    '-1': 'Decrease indent',
    '+1': 'Increase indent',
  },
  'ql-clean': 'Clear formatting',
};

export default {
  components: {
    quillEditor,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      content: null,
      editorOption: {
        placeholder: this.label,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [
              { align: '' },
              { align: 'center' },
              { align: 'right' },
              { align: 'justify' },
            ],
            [{ indent: '-1' }, { indent: '+1' }],
            ['clean'],
          ],
        },
        scrollingContainer: '.v-dialog',
      },
    };
  },
  computed: {
    editor() {
      return this.$refs.myTextEditor.quill;
    },
    htmlWithoutTags: function() {
      const matchTags = /(<([^>]+)>)/gi;
      return this.value.replace(matchTags, '');
    },
  },
  watch: {
    content(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.content = value;
    },
  },
  mounted() {
    this.content = this.value;
    // add tooltip
    const toolbar = this.editor.container.previousSibling;
    const toolbarElement = document.querySelector('.ql-toolbar');
    if (toolbarElement) {
      const buttons = toolbarElement.querySelectorAll('button');
      buttons.forEach(button => {
        if (buttonTooltips[button.className][button.value]) {
          button.setAttribute(
            'title',
            buttonTooltips[button.className][button.value]
          );
        } else {
          button.setAttribute('title', buttonTooltips[button.className]);
        }
      });
    }
  },
};
</script>

<style lang="scss">
.editor__error-message {
  padding-top: 0px;
}
.editor__error-message .v-input__slot {
  display: none;
}
.editor__label {
  .v-text-field__details {
    display: none;
  }
  .v-input__slot {
    &:before,
    &:after {
      display: none;
    }
    .v-text-field__slot {
      input,
      label:not(.v-label--active),
      ::after {
        display: none;
      }
    }
  }
}
//change the default font: 'Helvetica, Arial, sans-serif' to Roboto
.ql-container {
  font-family: 'Roboto', sans-serif;
}
.ql-editor em {
  font-family: 'Yu Gothic';
}
</style>
